import { Skeleton } from "@mantine/core";
import React, { useEffect, useState } from "react";

const imageCache = new Map<string, string>();

async function fetchImageAsDataUrl(src: string): Promise<string> {

	if (imageCache.has(src)) {
		return imageCache.get(src)!;
	}

	const res = await fetch(src, { cache: "force-cache" });
	if (!res.ok) throw new Error("Image fetch failed");
	const blob = await res.blob();
	const dataUrl: string = await new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result as string);
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
	imageCache.set(src, dataUrl);
	return dataUrl;
}

const CachedImage: React.FC<{
	src: string;
	alt: string;
	height?: number | string;
	width?: number | string;
	style?: React.CSSProperties;
}> = (props) => {
	const [imgUrl, setImgUrl] = useState<string | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let isMounted = true;
		setLoading(true);
		fetchImageAsDataUrl(props.src)
			.then((url) => {
				if (isMounted) {
					setImgUrl(url);
					setLoading(false);
				}
			})
			.catch(() => {
				if (isMounted) setLoading(false);
			});
		return () => {
			isMounted = false;
		};
	}, [props.src]);

	if (loading) {
		return (
			<Skeleton
				height={props.height ?? 180}
				width={props.width ?? "100%"}
				radius="md"
			/>
		);
	}

	return (
		<img
			src={imgUrl ?? ""}
			alt={props.alt}
			height={props.height}
			width={props.width}
			style={props.style}
		/>
	);
};

export default CachedImage;